import { useState, useEffect } from 'react';
import PropTypes from 'prop-types'; // Add for prop validation
import LoadingOverlay from './LoadingOverlay';
import ErrorOverlay from './ErrorOverlay';
import { getOneNote } from '../../util/backendController';
import { UI_ERR_COULD_NOT_LOAD } from '../../store/langStrings';
import queryString from 'query-string';

function LoadAndErrorOverlay({ pageName, onSuccessData }) {
  const [isFetching, setIsFetching] = useState(false);
  const [error, setError] = useState();

  useEffect(() => {
    getData();
  }, [pageName]); // Only run when pageName changes

  async function getData() {
    setIsFetching(true);
    setError(null);

    try {
      console.log('LEO pageName: ', pageName);
      let response;

      switch (pageName) {
        case 'App':
          const parsed = queryString.parse(window.location.search);
          const nId = parsed.nid;
          if (nId) {
            response = await getOneNote(nId);
          }

          break;
        case 'FlashcardPage':
          response = [];
          break;
        default:
          response = [];
      }

      onSuccessData(response);
    } catch (err) {
      console.log('LEO triggered error');
      setError(UI_ERR_COULD_NOT_LOAD);
    }

    setIsFetching(false);
  }

  function cancelError() {
    setError(null);
    getData();
  }

  if (error && !isFetching) {
    return (
      <ErrorOverlay message={error} isButton={true} onConfirm={cancelError} />
    );
  }

  if (isFetching) {
    return <LoadingOverlay />;
  }

  // Default fallback
  return null;
}

LoadAndErrorOverlay.propTypes = {
  pageName: PropTypes.string.isRequired,
  onSuccessData: PropTypes.func.isRequired,
};

export default LoadAndErrorOverlay;
